import React from 'react';
import {isEmpty,isUndefined} from 'lodash'
import { Chart } from "react-google-charts";
import axios from 'util/ApiDashboard'
import { useSelector,useDispatch } from 'react-redux';
import IntlMessages from 'util/IntlMessages';
import { decrypt,encrypt } from 'actions';

export const data = [
    ["Task", "Hours per Day"],
    ["Work", 11],
    ["Eat", 2],
    ["Commute", 2],
    ["Watch TV", 2],
    ["Sleep", 7], // CSS-style declaration
  ];

function ChartComponent(props) {
    const dispatch = useDispatch()
    const AuthUser = useSelector(state => state.auth.authUser)
    const [data,setData] = React.useState([])
    const [options,setoptions] = React.useState({
        backgroundColor: {
            fill:'transparent'    
        }
    })
    React.useEffect(()=>{
        setoptions({
            ...options,
            title:props.title
        })
    },[props.title])
    React.useEffect(()=>{
        console.log(props,"Editingggg333")
        setoptions({
            ...options,
            backgroundColor: {
                fill:'transparent'    
            }
        })
    },[props.BackGroudColor])
    React.useEffect(()=>{
        if(props.chartType === 'DonutChart'){
            setoptions({
                ...options,
                pieSliceText: 'none',
                pieHole: 0.8,
                colors:['rgb(71, 192, 194)']
            })
        }
        if(props.chartType === 'ColumnChart'){
            setoptions({
                ...options,
                series: {
                    0: { // Style for all series (all bars)
                      type: 'bars',
                      color: 'rgb(71, 192, 194)', // Change the color as needed
                    },
                },
                bar: { 
                    groupWidth: "15%",
                 }
            })
        }
        if(props.chartType === 'PieChart'){
            setoptions({
                ...options,
                pieSliceText: 'none',
                colors:['rgb(71, 192, 194)']
            })
        }
    },[props.chartType])
    console.log(options,"options")
    React.useEffect(()=>{
        if(!isEmpty(props.hAxis)){
            try{
        axios.get(`kontos/DashBoard/getCustomChartCL`,
        { params:encrypt(JSON.stringify({
            Afid:AuthUser.user_Afid,
            FilterOption:[],
            intervaltype:props.intervaltype,
            userid:AuthUser.user_id,
            XAxis:props.hAxis            
          }))
        })
        .then(res => {
              if(res.data.success){
                            let endata = decrypt(res.data.encryptedData,res.data.iv)
                            let ndate = JSON.parse(endata)
                            setData(ndate.results.data)
                            // this.setState({done: true}) 
                            } 
            
        })
    }catch(error){
        console.log(error)
    }
        }
    },[props])
    console.log(props,"Editingggg")
    return (
        <div className='d-flex align-items-center justify-content-center h-100 w-100'>
        {
            isEmpty(props.chartType)?
            <h1 className='m-0' style={{fontSize: 50, fontWeight: 500,
                color: isUndefined(props.FontColor)?"#fff":`${props.FontColor}`}}><IntlMessages id="sidebar.chart"/></h1>
            :
            data.length === 1?
            <h1 className='m-0' style={{fontSize: 50, fontWeight: 500,
            color: isUndefined(props.FontColor)?"#fff":`${props.FontColor}`}}>
                {`${isUndefined(props.title)?
                    <IntlMessages id="sidebar.chart"/>
                    :isEmpty(props.title)?`${props.hAxis}/${props.vAxis ===''?
                    <IntlMessages id="Table.Quantity"/>
                    :props.vAxis}`:props.title}`}
            </h1>
            :
            <Chart
            chartType={ props.chartType==="DonutChart"?"PieChart":props.chartType}
            width="100%"
            height="100%"
            backgroundColor={props.BackGroudColor}
            data={data}
            options={options}
          />
        }
      </div>
    );
}

export default ChartComponent;